import { atom } from "recoil";

export const blackListWithdrawalsEditModalStore = atom({
	key: "blackListWithdrawalsEditModalStore",
	default: {
		show: false,
		loaded: false,
		wallet: "",
		id: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
